export default "__VITE_ASSET__LPyly$h2__"